<template>
  <section class="mt-5">
    <div>
      <h2>クーリング・オフお申し出フォーム</h2>
      <div class="form-navi my-5">
        <ul class="d-flex">
          <li class="here">入力</li>
          <li>内容確認</li>
          <li>送信完了</li>
        </ul>
      </div>
      <div class="form-content">
        <p>
          クーリング・オフをお申し出の方は、下記フォームを入力のうえで、確認画面へ進むを押してください。
        </p>
        <div class="form-member my-5">
          <div class="inner">
            <form id="frmForm">
              <dl>
                <dt>申出日</dt>
                <dd>{{date}} </dd>
                <dt>サービス名<span class="rqr">必須</span></dt>
                <dd>
                  <select v-model="selected" ref="selected" class="px-3">
                    <option disabled value="">サービスを選んでください</option>
                    <option
                      v-for="option in options"
                      v-bind:value="option.name"
                      v-bind:key="option.id"
                    >
                      {{ option.name }}
                    </option>
                    <!-- <option>マナビス・ショッピング・クラブ</option> -->
                  </select>
                </dd>
                <dt>会員番号</dt>
                <dd>
                  <input v-model="no" type="tel" />
                </dd>
                <dt>ご契約者名<span class="rqr">必須</span></dt>
                <dd>
                  <input
                    v-model="name1"
                    ref="name1"
                    type="text"
                    class="input-name mr-3"
                    placeholder="(例)真奈"
                  />
                  <input
                    v-model="name2"
                    ref="name2"
                    type="text"
                    class="input-name"
                    placeholder="(例)美須子"
                  />
                </dd>
                <dt>
                  ご契約者名<br class="only_pc" />（フリガナ）<span class="rqr"
                    >必須</span
                  >
                </dt>
                <dd>
                  <input
                    v-model="nameKana1"
                    ref="nameKana1"
                    type="text"
                    class="input-name mr-3"
                    placeholder="(例)マナ"
                  />
                  <input
                    v-model="nameKana2"
                    ref="nameKana2"
                    type="text"
                    class="input-name"
                    placeholder="(例)ビスコ"
                  /><br />
                  <p>全角カタカナで入力してください。</p>
                </dd>
                <dt>郵便番号<span class="rqr">必須</span></dt>
                <dd>
                  <input v-model="zipCode" type="text" /><br />
                  <p>ハイフン(-)は除いてください。</p>
                </dd>
                <dt>住所<span class="rqr">必須</span></dt>
                <dd>
                  <input
                    ref="address"
                    v-model="address"
                    type="text"
                    class="w-100"
                  />
                </dd>
                <dt>電話番号<span class="rqr">必須</span></dt>
                <dd>
                  <input
                    ref="tel"
                    v-model="tel"
                    type="text"
                    class="input-w30"
                  /><br />
                  <p>ハイフン(-)は除いてください。</p>
                </dd>
                <dt>メールアドレス<span class="rqr">必須</span></dt>
                <dd>
                  <input
                    ref="txtMail"
                    v-model="txtMail"
                    type="email"
                    class="input-w60"
                  />
                </dd>
                <dt>その他ご要望</dt>
                <dd>
                  <textarea
                    v-model="ex"
                    type="text"
                    class="w-100"
                    placeholder="メッセージをご入力ください"
                  ></textarea>
                </dd>
              </dl>
              <div class="text-center mt-5">
                <input ref="check" v-model="check" type="checkbox" />
                <label>上記契約のクーリング・オフを申し出ます。</label>
              </div>
              <div class="box-p-20 text-center mt-5">
                <button
                  v-on:click="PutData"
                  id="btnConfirm"
                  type="button"
                  class="confirm-01 clear"
                >
                  確認画面へ進む
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ:0120-268-510<br />
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>
<script>
import Message from "@/modules/Message";
import Utl from "@/modules/Utl";
import Request from "@/modules/Request";
let request = new Request();
import Authenticate from "@/modules/Authenticate";
import Store from "../../modules/Store";
let store = new Store();
let auth = new Authenticate();
export default {
  data() {
    return {
      selected: "",
      options: [
        { id: 1, name: "マナビス・スキンケア・クラブ" },
        { id: 2, name: "マナビス・ヘアピース" },
      ],
      date: "",
      no: "",
      name: "",
      name1: "",
      name2: "",
      nameKana: "",
      nameKana1: "",
      nameKana2: "",
      zipCode: "",
      address: "",
      tel: "",
      txtMail: "",
      ex: "",
      check: false,
      uux: "",
    };
  },
  mounted() {
    var today = new Date();
    let month = today.getMonth()+1;
    this.date = today.getFullYear() + "年" +  month + "月"+ today.getDate() + "日";
    this.getSession();
    this.getData();
    window.scroll(0, 0);
  },
  methods: {
    getSession() {
      console.log("getSession");
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getSession",
        [],
        true
      );
      console.log(requestParams);
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          console.log(data);
          if (auth.getNoLoginUid() == "") {
            this.uux = data.uux;
            auth.setNoLoginUid(this.uux);
          }
        });
    },
    getData() {
      if (store.get("cancel") != "") {
        let items = JSON.parse(store.get("cancel"));
        this.selected = items["selected"];
        this.no = items["no"];
        this.name = items["name"];
        this.name1 = items["name1"];
        this.name2 = items["name2"];
        this.nameKana = items["nameKana"];
        this.nameKana1 = items["nameKana1"];
        this.nameKana2 = items["nameKana2"];
        this.zipCode = items["zipCode"];
        this.address = items["address"];
        this.tel = items["tel"];
        this.txtMail = items["txtMail"];
        this.ex = items["ex"];
      }
    },
    PutData() {
      if (!this.chkSelected()) return;
      if (!this.chkName()) return;
      this.name = this.name1 + " " + this.name2;
      if (!this.chkKana()) return;
      this.nameKana = this.nameKana1 + " " + this.nameKana2;
      if (!this.chkZipCode()) return;
      if (!this.chkAddrress()) return;
      if (!this.chkTel()) return;
      if (!this.chkMailAddress()) return;
      if (!this.chkConsent()) return;
      // let store = new Store();
      let params = {
        selected: this.selected,
        date: this.date,
        no: this.no,
        name: this.name,
        name1: this.name1,
        name2: this.name2,
        nameKana: this.nameKana,
        nameKana1: this.nameKana1,
        nameKana2: this.nameKana2,
        zipCode: this.zipCode,
        address: this.address,
        tel: this.tel,
        txtMail: this.txtMail,
        ex: this.ex,
      };
      let json = JSON.stringify(params);
      store.set("cancel", json);

      this.$router.push({
        path: "/cancel/confirm",
        query: {
          ref: this.$route.query.ref,
        },
      });
    },
    chkSelected() {
      let mes = Utl.chkMustInput("サービス名", this.selected);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.selected.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkName() {
      let mes = Utl.chkMustInput("氏名の姓", this.name1);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.name1.focus();
          },
        });
        return false;
      }
      mes = Utl.chkCanUseChars("氏名の姓", this.name1);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.name1.focus();
          },
        });
        return false;
      } else {
        let mes = Utl.chkMustInput("氏名の名", this.name2);
        if (mes.length != 0) {
          Message.error().fire({
            title: mes,
            didClose: () => {
              this.$refs.name2.focus();
            },
          });
          return false;
        }
        mes = Utl.chkCanUseChars("氏名の名", this.name2);
        if (mes.length != 0) {
          Message.error().fire({
            title: mes,
            didClose: () => {
              this.$refs.name2.focus();
            },
          });
          return false;
        }
      }
      return true;
    },
    chkKana() {
      let mes = Utl.chkMustInput("氏名(フリガナ)の姓", this.nameKana1);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.nameKana1.focus();
          },
        });
        return false;
      }
      mes = Utl.chkCanUseKana("氏名(フリガナ)の姓", this.nameKana1);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.nameKana1.focus();
          },
        });
        return false;
      } else {
        mes = Utl.chkMustInput("氏名(フリガナ)の名", this.nameKana2);
        if (mes.length != 0) {
          Message.error().fire({
            title: mes,
            didClose: () => {
              this.$refs.nameKana2.focus();
            },
          });
          return false;
        }
        mes = Utl.chkCanUseKana("氏名(フリガナ)の名", this.nameKana2);
        if (mes.length != 0) {
          Message.error().fire({
            title: mes,
            didClose: () => {
              this.$refs.nameKana2.focus();
            },
          });
          return false;
        }
      }
      return true;
    },
    chkZipCode() {
      let mes = Utl.chkMustInput("郵便番号", this.zipCode);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.zipCode.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkAddrress() {
      let mes = Utl.chkMustInput("住所", this.address);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.address.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkTel() {
      let mes = Utl.chkMustInput("電話番号", this.tel);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.address.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkMailAddress() {
      let mes = Utl.chkMustInput("メールアドレス", this.txtMail);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.txtMail.focus();
          },
        });
        return false;
      }
      mes = Utl.chkMailAddress("メールアドレス", this.txtMail);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.txtMail.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkConsent() {
      if (this.check != true) {
        Message.error().fire({
          title:
            "契約解除を希望される方は「上記契約のクーリング・オフを申し出ます」にチェックを入れてください。",
          didClose: () => {
            this.$refs.check.focus();
          },
        });
        return false;
      }
      return true;
    },
  },
};
</script>
